export * from './regexp-validators';

export const COMMON_MOBILE_BREAKPOINT = 480;
